import React, { useState } from 'react';

/**
 * ReplyTek logo (public/logo.png). Falls back to "R" if the image fails to load.
 */
export default function BrandMark({ imgClassName, fallbackClassName }) {
  const [failed, setFailed] = useState(false);
  if (failed) {
    return <div className={fallbackClassName}>R</div>;
  }
  return (
    <img
      src="/logo.png"
      alt="ReplyTek"
      className={imgClassName}
      onError={() => setFailed(true)}
    />
  );
}
